import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import {
  LayoutDashboard, FileText, Sparkles, Lightbulb, Clock, CheckSquare, CalendarDays,
  Building2, Users, Rss, Mail, Megaphone, Search, Settings, LogOut, ExternalLink, BarChart3
} from "lucide-react";

const NAV = [
  ["/admin", "Dashboard", LayoutDashboard, true],
  ["/admin/articles", "Articles", FileText],
  ["/admin/candidates", "Candidate Stories", Lightbulb],
  ["/admin/ai-desk", "AI Editorial Desk", Sparkles],
  ["/admin/analytics", "Analytics", BarChart3],
  ["/admin/calendar", "Content Calendar", CalendarDays],
  ["/admin/companies", "Companies", Building2],
  ["/admin/sources", "Sources", Rss],
  ["/admin/newsletter", "Newsletter", Mail],
  ["/admin/sponsored", "Sponsored", Megaphone],
  ["/admin/settings", "Settings", Settings],
];

export function AdminLayout({ children, title }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const doLogout = async () => { await logout(); nav("/admin/login"); };

  return (
    <div className="min-h-screen bg-admbg text-admtext flex">
      {/* Sidebar */}
      <aside className="w-60 shrink-0 border-r border-admborder flex flex-col fixed h-screen">
        <div className="p-5 border-b border-admborder">
          <div className="font-serif font-bold text-xl text-admtext">THE FIN DESK</div>
          <div className="text-[10px] uppercase tracking-[0.2em] text-cyan mt-0.5">Editorial Console</div>
        </div>
        <nav className="flex-1 overflow-y-auto py-3 no-scrollbar">
          {NAV.map(([to, label, Icon, end]) => (
            <NavLink key={to} to={to} end={end} data-testid={`admin-nav-${label.toLowerCase().replace(/ /g,"-")}`}
              className={({ isActive }) => `flex items-center gap-3 px-5 py-2.5 text-sm transition-colors ${isActive ? "bg-admcard text-cyan border-l-2 border-cyan" : "text-admtext2 hover:text-admtext hover:bg-admcard/50 border-l-2 border-transparent"}`}>
              <Icon size={16} /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-admborder">
          <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-2 text-xs text-admtext2 hover:text-admtext mb-3"><ExternalLink size={14} /> View publication</a>
          <div className="flex items-center justify-between">
            <div className="text-xs text-admtext2 truncate">{user?.email}</div>
            <button onClick={doLogout} data-testid="admin-logout" className="text-admtext2 hover:text-crimson"><LogOut size={15} /></button>
          </div>
        </div>
      </aside>

      {/* Main */}
      <div className="flex-1 ml-60">
        <header className="h-14 border-b border-admborder flex items-center px-6 sticky top-0 bg-admbg/90 backdrop-blur z-20">
          <h1 className="font-serif text-xl text-admtext">{title}</h1>
        </header>
        <div className="p-6">{children}</div>
      </div>
    </div>
  );
}
